import { Provider } from '@angular/core';

import { IconsConfig } from './icons.config';

export const provideFcomIcons = (config?: IconsConfig): Provider[] => {
  return [{ provide: IconsConfig, useValue: config }];
};
